import servicesJson from "../services.json" with { type: "json" };

export interface ServiceDefinition {
  /** Short service name — also the folder under src/generated/. */
  readonly name: string;
  /** Host port published by compose.dev.yml. */
  readonly port: number;
  /** PostgreSQL schema owned by the service (informational). */
  readonly schema: string;
}

export interface ServicesConfig {
  readonly defaults: {
    readonly host: string;
    readonly openapiPath: string;
    readonly timeoutMs: number;
  };
  readonly services: readonly ServiceDefinition[];
}

export const SERVICES_CONFIG: ServicesConfig = servicesJson;
export const SERVICES: readonly ServiceDefinition[] = SERVICES_CONFIG.services;
export const SERVICE_NAMES = SERVICES.map((s) => s.name);
export type ServiceName = (typeof SERVICES)[number]["name"];

/** `catalog` → `API_CLIENT_CATALOG_URL` */
export function serviceEnvVar(name: string): string {
  return `API_CLIENT_${name.toUpperCase().replace(/[^A-Z0-9]/g, "_")}_URL`;
}

/**
 * Base URL for a service, in priority order:
 * 1. `API_CLIENT_<NAME>_URL` (explicit per service)
 * 2. `API_CLIENT_BASE_URL_TEMPLATE` with `{service}` / `{port}` placeholders (gateway mode)
 * 3. `<defaults.host>:<port>` (compose dev ports)
 */
export function resolveBaseUrl(
  service: ServiceDefinition,
  env: Readonly<Record<string, string | undefined>>,
  config: ServicesConfig = SERVICES_CONFIG,
): string {
  const explicit = env[serviceEnvVar(service.name)];
  if (explicit) {
    return explicit.replace(/\/+$/, "");
  }
  const template = env["API_CLIENT_BASE_URL_TEMPLATE"];
  if (template) {
    return template
      .replace("{service}", service.name)
      .replace("{port}", String(service.port))
      .replace(/\/+$/, "");
  }
  return `${config.defaults.host}:${service.port}`;
}
